/* eslint-disable */
export default {
	TOGGLE_LOADING (state) {
		state.callingAPI = !state.callingAPI
	},
	TOGGLE_SEARCHING (state) {
		state.searching = (state.searching === '') ? 'loading' : ''
	},
	SET_USER (state, user) {
		state.user = user
	},
	SET_TOKEN (state, token) {
		state.token = token
	},
	ADD_API_DATA (state, payload) {
		state.apiData[payload.type].push(payload.item)
	},
	CLEAR_API_DATA (state, type) {
		if (type === '*') {
			for (let key in state.apiData) {
				state.apiData[key] = []
			}
		} else {
			state.apiData[type] = []
		}
	},
	SYNC_API_DATA (state, payload) {
		if (payload.items) {
			state.apiData[payload.type] = payload.items
		}
	},
	SYNC_PENDIENTES (state, asset) {
		state.pendientes[asset] = state.pendientes[asset] === 0 ? 1 : 0
	},
	SYNC_ONLINE (state, value) {
		state.online = value
	},
	SET_PAGE_TITLE (state, value) {
		state.page.title = value
	},
	SHOW_DANGER_ALERT (state, alert) {
		state.generalAlert.title = alert.title
		state.generalAlert.message = alert.message
		state.generalAlert.type = 'danger'
		state.generalAlert.icon = 'ban'
		state.generalAlert.show = true
	},
	SHOW_SUCCESS_ALERT (state, alert) {
		state.generalAlert.title = alert.title
		state.generalAlert.message = alert.message
		state.generalAlert.type = 'success'
		state.generalAlert.icon = 'check'
		state.generalAlert.show = true
	},
	HIDE_GENERAL_ALERT (state) {
		state.generalAlert.title = ''
		state.generalAlert.message = ''
		state.generalAlert.type = ''
		state.generalAlert.icon = ''
		state.generalAlert.show = false
	},	
	DATA_LOADED (state) {
		state.loaded =  true
	},
	SET_JSON_STATIC (state, json) {
		state.jsonStatic = json
	}
}



// WEBPACK FOOTER //
// ./src/store/mutations.js